"use client";
import { useParams } from "react-router-dom";
import Dropdown from "../../Components/Fields/Dropdown";
import FileInput from "../../Components/Fields/FileInput";
import Journal from "../../Components/Fields/Journal";
import String from "../../Components/Fields/String";
import { useStore } from "../../Components/StateProvider";
import {
  CheckMandatory,
  DeleteRecord,
  ErrorAlert,
  saveRecord,
  SuccessAlert,
  WarningAlert,
} from "../../functions/api";
import { getlocal } from "../../functions/localstorage";
import React, { useEffect } from "react";
import { PrimaryBTN } from "../../Constancs/cssconst";
import Attachement from "../../Components/Fields/Attachement";
import { IoMdAdd, IoMdTrash, IoMdCloudUpload } from "react-icons/io";
import LoadingSpinner from "../../Components/Elements/LoadingSpinner";

const FilmFormCreate = () => {
  const params = useParams();
  const store = useStore();

  const init = {
    activeform: 0,
    film: params.filmname || "",
    category_of_Service: "",
    nature_of_Service: "",
    nature_of_Service_sample: "",
    name_of_Artist: "",
    email: "",
    phone_no: "",
    father_Name: "",
    addres_of_Artist: "",
    category_Id: "1",
    client_Id: params.clientId || "",
    paN_Number: "",
    aadhar_Number: "",
    aadhar_docs_url: "",
    PAN: "",
    Aadhar: "",
    gst: "",
    GST_Certificate: "",
    payment_Deal: "",
    remarks: "",
    total_Remuneration: "",
    no_of_Shooting_Days: "",
    no_of_Months: "",
    payment_Trance: [
      { name: "Advance", value: "20000" },
      { name: "50%", value: "50000" },
      { name: "10%", value: "100000" },
    ],
    assistants_Payments: "",
    account_no: "",
    account_holder_Name: "",
    bank_Name: "",
    branch: "",
    ifsC_Code: "",
    attachmenturl: [],
    paymentAttachmentURL: [],
    order: [
      { Process: "Personal Details", stage: false },
      { Process: "ID Proofs", stage: false },
      { Process: "Bank Details", stage: false },
      { Process: "Payments & Shooting Days", stage: false },
    ],
  };

  useEffect(() => {
    store.setmodule("clientform" + params.categoryid, init);
    store.setvalue("film", params.filmname);
    store.setprops("film", { readonly: true });
    mandatoryfields(0);
  }, [params.categoryid]);

  function mandatoryfields(order) {
    if (order === 0) {
      store.setprops("name_of_Artist", { mandatory: true });
      store.setprops("nature_of_Service_sample", { hidden: true });
      store.setprops("email", { mandatory: true });
      store.setprops("account_no", { mandatory: false });
      store.setprops("account_holder_Name", { mandatory: false });
      store.setprops("ifsC_Code", { mandatory: false });
      store.setprops("no_of_Shooting_Days", { mandatory: false });
      store.setprops("payment_Trance", { mandatory: false });
    } else if (order === 1) {
      store.setprops("name_of_Artist", { mandatory: false });
      store.setprops("email", { mandatory: false });
      store.setprops("account_no", { mandatory: false });
      store.setprops("account_holder_Name", { mandatory: false });
      store.setprops("ifsC_Code", { mandatory: false });
      store.setprops("no_of_Shooting_Days", { mandatory: false });
      store.setprops("payment_Trance", { mandatory: false });
    } else if (order === 2) {
      store.setprops("name_of_Artist", { mandatory: false });
      store.setprops("email", { mandatory: false });
      store.setprops("account_no", { mandatory: true });
      store.setprops("account_holder_Name", { mandatory: true });
      store.setprops("ifsC_Code", { mandatory: true });
      store.setprops("no_of_Shooting_Days", { mandatory: false });
      store.setprops("payment_Trance", { mandatory: false });
    } else if (order === 3) {
      store.setprops("name_of_Artist", { mandatory: false });
      store.setprops("email", { mandatory: false });
      store.setprops("account_no", { mandatory: false });
      store.setprops("account_holder_Name", { mandatory: false });
      store.setprops("ifsC_Code", { mandatory: false });
      store.setprops("no_of_Shooting_Days", { mandatory: false });
      store.setprops("payment_Trance", { mandatory: true });
    }
  }

  function OnSubmit() {
    store.startLoading();
    const ActualRecord = store.getrecord("clientform" + params.categoryid);
    let data = { ...ActualRecord };
    data = {
      formDetails: {
        form_id: params.formid,
        category_id: Number(params.categoryid),
        contact_id: Number(params.clientId),
        status: "Submitted",
        film_id: Number(params.filmid),
      },
      industrialNames: {
        film: data.film,
        category_of_Service: data.category_of_Service,
        nature_of_Service:
          data.nature_of_Service === "Others"
            ? data.nature_of_Service_sample
            : data.nature_of_Service,
        name_of_Artist: data.name_of_Artist,
        email: data.email,
        phone_no: data.phone_no,
        father_Name: data.father_Name,
        addres_of_Artist: data.addres_of_Artist,
      },
      idProofDocs: {
        paN_Number: data.paN_Number,
        paN_docs_url: data.paN_docs_url,
        aadhar_Number: data.aadhar_Number,
        aadhar_docs_url: data.aadhar_docs_url,
        gst: data.gst === "true" ? true : false,
        gsT_doc_url: data.gsT_doc_url,
        attachmenturl: data.attachmenturl,
      },
      payment: {
        payment_Deal: data.payment_Deal,
        total_Remuneration: data.total_Remuneration,
        no_of_Shooting_Days: data.no_of_Shooting_Days,
        no_of_Months: data.no_of_Months,
        payment_Trance: JSON.stringify(data.payment_Trance),
        assistants_Payments: data.assistants_Payments,
        remarks: data.remarks,
      },
      bankDetails: {
        account_no: data.account_no,
        account_holder_Name: data.account_holder_Name,
        bank_Name: data.bank_Name,
        branch: data.branch,
        ifsC_Code: data.ifsC_Code,
        attachmenturl: data.paymentAttachmentURL,
      },
    };

    saveRecord("/forms/addformdetails", data).then((res) => {
      if (res.success) {
        let orderdata = order;
        SuccessAlert("Form Submitted Successfully");
        orderdata[store.getvalue("activeform")].stage = true;
        store.setvalue("order", orderdata);
        store.setvalue("activeform", 4);
        store.stopLoading();
      } else {
        ErrorAlert("Form error. Please check all the sections");
        store.stopLoading();
      }
    });
  }

  const order =
    (getlocal("records") &&
      getlocal("records")["clientform" + params.categoryid] &&
      getlocal("records")["clientform" + params.categoryid].order) ||
    [];

  const activeStep = store.getvalue("activeform") || 0;

  return (
    <div className="min-h-screen w-full bg-[#f8fafc] flex flex-col md:flex-row font-sans">
      {/* Google Fonts import */}
      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@500;600;700;850&display=swap');
        body {
          font-family: 'Inter', sans-serif;
          background-color: #f8fafc;
        }
      `}</style>

      {/* Left progress sidebar */}
      <Sidebar Title="Onboarding Information Portal" order={order} />

      {/* Right side form card area */}
      <div className="flex-1 flex flex-col justify-between p-6 md:p-12 max-h-screen overflow-y-auto">
        <div className="max-w-4xl w-full mx-auto flex flex-col justify-between h-full">
          <div>
            {/* Header info */}
            <div className="mb-8 border-b border-[#e2e8f0] pb-6 flex justify-between items-end">
              <div>
                <h1 className="text-2xl font-extrabold text-[#000042] tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {activeStep === 4 ? "Submission Status" : order[activeStep]?.Process}
                </h1>
                <p className="text-xs text-slate-500 mt-1.5 font-medium">
                  {activeStep === 4 
                    ? "Thank you for submitting your details." 
                    : "Please fill out all the mandatory fields carefully."}
                </p>
              </div>
              <div className="hidden sm:block text-right">
                <span className="text-[10px] uppercase font-bold tracking-wider text-slate-400">Step {activeStep === 4 ? 4 : activeStep + 1} of 4</span>
                <div className="w-24 h-1.5 bg-slate-200 rounded-full mt-1.5 overflow-hidden">
                  <div 
                    className="h-full bg-[#000042] transition-all duration-500" 
                    style={{ width: `${activeStep === 4 ? 100 : (activeStep + 1) * 25}%` }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Form card sheet */}
            <div className="bg-[#ffffff] rounded-2xl border border-[#e2e8f0] shadow-[0_4px_20px_rgba(0,0,0,0.02)] p-6 md:p-8">
              {activeStep === 0 && <FilmDetails params={params} store={store} />}
              {activeStep === 1 && <PANDetails params={params} store={store} />}
              {activeStep === 2 && <AccountDetails params={params} store={store} />}
              {activeStep === 3 && (
                <>
                  {store.getsystemvalue("loading") && <LoadingSpinner />}
                  <ShootingDetails params={params} store={store} />
                </>
              )}
              {activeStep === 4 && (
                <SuccessSubmittion
                  MandatoryFunction={mandatoryfields}
                  initialValue_for_Reset={init}
                  store={store}
                />
              )}
            </div>
          </div>

          {/* Action Footer Navigation Buttons */}
          {activeStep !== 4 && (
            <div className="flex justify-end items-center gap-4 mt-8 pt-6 border-t border-[#e2e8f0]">
              {activeStep > 0 && (
                <button
                  className="px-6 py-2.5 bg-[#ffffff] border border-[#e2e8f0] text-slate-700 rounded-xl hover:bg-[#f8fafc] hover:text-slate-900 transition-all font-semibold text-xs cursor-pointer shadow-sm"
                  onClick={() => {
                    let orderdata = order;
                    orderdata[activeStep - 1].stage = false;
                    store.setvalue("order", orderdata);
                    store.setvalue("activeform", activeStep - 1);
                    mandatoryfields(activeStep - 1);
                  }}
                >
                  Back
                </button>
              )}
              <button
                className="px-8 py-2.5 bg-[#000042] text-[#ffffff] rounded-xl hover:bg-[#09095c] hover:shadow-lg active:scale-[0.98] transition-all font-semibold text-xs border-0 cursor-pointer shadow-md"
                onClick={() => {
                  if (CheckMandatory("clientform" + params.categoryid, store)) {
                    if (order.length - 1 === activeStep) {
                      OnSubmit();
                    } else {
                      let orderdata = order;
                      orderdata[activeStep].stage = true;
                      store.setvalue("order", orderdata);
                      store.setvalue("activeform", activeStep + 1);
                      mandatoryfields(activeStep + 1);
                    }
                  }
                }}
              >
                {order.length - 1 === activeStep ? "Submit Information" : "Next Step"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

function DeleteAttachement(URL) {
  return DeleteRecord("/files/deletefiles?key=" + URL);
}

function Sidebar({ Title, order }) {
  const store = useStore();
  const activeStep = store.getvalue("activeform") || 0;

  return (
    <div className="bg-[#000042] text-[#ffffff] md:w-[320px] shrink-0 p-6 md:p-8 flex flex-col justify-between border-b md:border-b-0 md:border-r border-[#1a1a54]">
      <div>
        <div className="flex flex-col items-center mb-8 bg-[#000030]/80 p-5 rounded-2xl border border-white/5 shadow-inner">
          <img src="/Assets/images/Logo.png" className="h-14 w-22 object-contain mb-3 hover:scale-105 transition-all duration-300" alt="Logo" />
          <span className="font-extrabold text-xs tracking-widest uppercase text-[#FBE57B] mt-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Absolute Legal</span>
        </div>
        <div className="text-lg md:text-xl font-bold tracking-tight mb-8" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {Title}
        </div>

        {/* Wizard Steps indicator list */}
        <div className="flex flex-row md:flex-col gap-4 md:gap-8 overflow-x-auto md:overflow-x-visible pb-4 md:pb-0">
          {order.map((item, index) => {
            const isActive = activeStep === index;
            const isCompleted = item.stage;
            return (
              <div
                className={`flex items-center gap-4 shrink-0 transition-opacity duration-300 ${
                  isActive ? "opacity-100" : "opacity-50"
                }`}
                key={index}
              >
                <div className="relative flex flex-col items-center">
                  <div
                    className={`rounded-full w-8 h-8 flex justify-center items-center text-xs font-bold border-2 transition-all duration-300 ${
                      isCompleted
                        ? "bg-[#FBE57B] text-[#000042] border-[#FBE57B]"
                        : isActive
                        ? "bg-transparent text-[#ffffff] border-[#FBE57B]"
                        : "bg-transparent text-slate-400 border-slate-600"
                    }`}
                  >
                    {isCompleted ? "✓" : index + 1}
                  </div>
                  {order.length - 1 !== index && (
                    <div
                      className={`hidden md:block w-0.5 h-10 border-l-2 my-1 transition-colors duration-300 ${
                        isCompleted ? "border-[#FBE57B]" : "border-slate-700"
                      }`}
                    ></div>
                  )}
                </div>
                <div className="text-xs font-semibold tracking-wide text-left">
                  {item.Process}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="hidden md:block pt-8 border-t border-white/5">
        <p className="text-[10px] text-slate-400 font-medium">© {new Date().getFullYear()} Absolute Legal. Secure portal.</p>
      </div>
    </div>
  );
}

function FilmDetails({ store, params }) {
  const customStringClass = {
    field: "flex flex-col gap-1.5 w-full",
    input: "w-full px-4 py-2.5 bg-[#f8fafc] border border-[#e2e8f0] rounded-xl text-sm text-[#1e293b] placeholder-[#94a3b8] focus:outline-none focus:border-[#4f46e5] focus:bg-[#ffffff] focus:shadow-[0_0_0_4px_rgba(79,70,229,0.05)] transition-all duration-300",
    lable: "w-fit text-xs font-semibold text-[#475569]"
  };

  return (
    <div className="flex flex-col gap-6">
      <div>
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Film / Project Association</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
          <String name="film" label="Film Name" doubleline={true} className={customStringClass} />
          
          <div className="flex flex-col gap-1.5 w-full">
            <Dropdown
              name="nature_of_Service"
              label="Nature Of Service"
              doubleline={true}
              className={{
                field: "flex flex-col gap-1.5 w-full px-0",
                lable: "w-fit text-xs font-semibold text-[#475569]",
                input: "w-full text-sm rounded-xl focus:border-[#4f46e5] transition-all"
              }}
              list={[
                { value: "Major Artist", label: "Major Artist" },
                { value: "Supporting Artist", label: "Supporting Artist" },
                { value: "Writer", label: "Writer" },
                { value: "Co-Writer", label: "Co-Writer" },
                { value: "Director", label: "Director" },
                { value: "Co-Director", label: "Co-Director" },
                { value: "Dialogue Writer", label: "Dialogue Writer" },
                { value: "Associate Director", label: "Associate Director" },
                { value: "Assistant Director", label: "Assistant Director" },
                { value: "Production Executive", label: "Production Executive" },
                { value: "Production Manager", label: "Production Manager" },
                { value: "Cinematographer", label: "Cinematographer" },
                { value: "Art Director", label: "Art Director" },
                { value: "Costume Designer", label: "Costume Designer" },
                { value: "Costumer", label: "Costumer" },
                { value: "Stunt Choreographer", label: "Stunt Choreographer" },
                { value: "Makeup Man", label: "Makeup Man" },
                { value: "Still Photographer", label: "Still Photographer" },
                { value: "Dance Choreographer", label: "Dance Choreographer" },
                { value: "Editor", label: "Editor" },
                { value: "Script Consultant", label: "Script Consultant" },
                { value: "Others", label: "Others" },
              ]}
              onchange={(e) => {
                if (e === "Others") {
                  store.setprops("nature_of_Service_sample", { mandatory: true });
                } else {
                  store.setprops("nature_of_Service_sample", { hidden: true });
                  store.setvalue("nature_of_Service_sample", "");
                }
              }}
            />
          </div>

          <String
            name="nature_of_Service_sample"
            label="Specific Nature (If Others)"
            doubleline={true}
            className={customStringClass}
          />

          <Dropdown
            name="category_of_Service"
            label="Category of Service"
            doubleline={true}
            className={{
              field: "flex flex-col gap-1.5 w-full px-0",
              lable: "w-fit text-xs font-semibold text-[#475569]",
              input: "w-full text-sm rounded-xl focus:border-[#4f46e5] transition-all"
            }}
            list={[
              { value: "artist", label: "Artist" },
              { value: "technician", label: "Technician" },
            ]}
          />
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Personal Information</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
          <String
            name="name_of_Artist"
            label="Full Name (As per Govt. ID)"
            doubleline={true}
            className={customStringClass}
          />
          <String name="father_Name" label="Father's Name" doubleline={true} className={customStringClass} />
          <String name="email" label="E-Mail Address" doubleline={true} className={customStringClass} />
          <String name="phone_no" label="Contact Number" doubleline={true} className={customStringClass} />
          <div className="col-span-1 md:col-span-2">
            <Journal 
              name="addres_of_Artist" 
              label="Permanent Address" 
              doubleline={true} 
              className={{
                field: "flex flex-col gap-1.5 w-full",
                input: "w-full min-h-[90px] px-4 py-2.5 bg-[#f8fafc] border border-[#e2e8f0] rounded-xl text-sm text-[#1e293b] focus:outline-none focus:border-[#4f46e5] focus:bg-[#ffffff] transition-all duration-300",
                lable: "w-fit text-xs font-semibold text-[#475569]"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function PANDetails({ store, params }) {
  const customStringClass = {
    field: "flex flex-col gap-1.5 w-full",
    input: "w-full px-4 py-2.5 bg-[#f8fafc] border border-[#e2e8f0] rounded-xl text-sm text-[#1e293b] placeholder-[#94a3b8] focus:outline-none focus:border-[#4f46e5] focus:bg-[#ffffff] transition-all duration-300",
    lable: "w-fit text-xs font-semibold text-[#475569]"
  };

  const uploadBoxStyle = "flex items-center gap-3 px-4 py-3 bg-[#f8fafc] border border-[#e2e8f0] rounded-xl text-xs text-slate-700 font-semibold cursor-pointer hover:bg-slate-100 transition-colors shadow-sm";

  return (
    <div className="flex flex-col gap-6">
      <div>
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Government ID & Proofs</span>
        </div>
        
        {/* PAN Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4 items-end">
          <String name="paN_Number" label="PAN Card Number" doubleline={true} className={customStringClass} />
          <div className="flex flex-col gap-1.5">
            <span className="text-xs font-semibold text-[#475569]">PAN Card Copy (PDF/Image)</span>
            <div className="flex items-center gap-3">
              {store.getvalue("paN_docs_url") ? (
                <div className="flex items-center gap-3 bg-[#f0f9ff] border border-[#bae6fd] p-2 rounded-xl text-xs w-full justify-between">
                  <Attachement name="paN_docs_url" fileurl={store.getvalue("paN_docs_url")} />
                  <button
                    className="p-1 hover:bg-[#e0f2fe] text-red-500 rounded-lg flex items-center justify-center cursor-pointer"
                    onClick={() => {
                      DeleteAttachement(store.getvalue("paN_docs_url")).then((res) => {
                        if (res.success) {
                          store.setvalue("paN_docs_url", "");
                          SuccessAlert("PAN copy removed");
                        } else {
                          WarningAlert("Failed to remove attachment");
                        }
                      });
                    }}
                  >
                    <IoMdTrash size={16} />
                  </button>
                </div>
              ) : (
                <div className="w-full">
                  <FileInput name="paN_docs_url" doubleline={true} prefix={params.formid} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Aadhaar Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-6 items-end">
          <String name="aadhar_Number" label="Aadhaar Card Number" doubleline={true} className={customStringClass} />
          <div className="flex flex-col gap-1.5">
            <span className="text-xs font-semibold text-[#475569]">Aadhaar Card Copy (PDF/Image)</span>
            <div className="flex items-center gap-3">
              {store.getvalue("aadhar_docs_url") ? (
                <div className="flex items-center gap-3 bg-[#f0f9ff] border border-[#bae6fd] p-2 rounded-xl text-xs w-full justify-between">
                  <Attachement name="aadhar_docs_url" fileurl={store.getvalue("aadhar_docs_url")} />
                  <button
                    className="p-1 hover:bg-[#e0f2fe] text-red-500 rounded-lg flex items-center justify-center cursor-pointer"
                    onClick={() => {
                      DeleteAttachement(store.getvalue("aadhar_docs_url")).then((res) => {
                        if (res.success) {
                          store.setvalue("aadhar_docs_url", "");
                          SuccessAlert("Aadhaar copy removed");
                        } else {
                          WarningAlert("Failed to remove attachment");
                        }
                      });
                    }}
                  >
                    <IoMdTrash size={16} />
                  </button>
                </div>
              ) : (
                <div className="w-full">
                  <FileInput name="aadhar_docs_url" doubleline={true} prefix={params.formid} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>GST Details</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4 items-end">
          <Dropdown
            name="gst"
            label="GST Registration Status"
            doubleline={true}
            className={{
              field: "flex flex-col gap-1.5 w-full px-0",
              lable: "w-fit text-xs font-semibold text-[#475569]",
              input: "w-full text-sm rounded-xl focus:border-[#4f46e5]"
            }}
            list={[
              { value: "true", label: "Registered" },
              { value: "false", label: "Un-Registered" },
            ]}
          />
          <div className="flex flex-col gap-1.5">
            <span className="text-xs font-semibold text-[#475569]">GST Certificate (Optional)</span>
            <div className="flex items-center gap-3">
              {store.getvalue("gsT_doc_url") ? (
                <div className="flex items-center gap-3 bg-[#f0f9ff] border border-[#bae6fd] p-2 rounded-xl text-xs w-full justify-between">
                  <Attachement name="gsT_doc_url" fileurl={store.getvalue("gsT_doc_url")} />
                  <button
                    className="p-1 hover:bg-[#e0f2fe] text-red-500 rounded-lg flex items-center justify-center cursor-pointer"
                    onClick={() => {
                      DeleteAttachement(store.getvalue("gsT_doc_url")).then((res) => {
                        if (res.success) {
                          store.setvalue("gsT_doc_url", "");
                          SuccessAlert("GST certificate removed");
                        } else {
                          WarningAlert("Failed to remove attachment");
                        }
                      });
                    }}
                  >
                    <IoMdTrash size={16} />
                  </button>
                </div>
              ) : (
                <div className="w-full">
                  <FileInput name="gsT_doc_url" doubleline={true} prefix={params.formid} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Other Supporting Documents</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div className="col-span-1 md:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {store.getvalue("attachmenturl")?.length > 0 ? (
                store.getvalue("attachmenturl").map((item, index) => (
                  <div className="flex items-center justify-between border border-[#e2e8f0] p-3 rounded-xl bg-slate-50 text-xs" key={index}>
                    <Attachement name={"attachmenturl"} fileurl={item} />
                    <button
                      className="p-1 hover:bg-slate-200 text-red-500 rounded-lg cursor-pointer"
                      onClick={() => {
                        let arr = store.getvalue("attachmenturl").filter((_, i) => i !== index);
                        DeleteAttachement(item).then((res) => {
                          if (res.success) {
                            store.setvalue("attachmenturl", arr);
                          } else {
                            WarningAlert("Unable to remove attachment");
                          }
                        });
                      }}
                    >
                      <IoMdTrash size={16} />
                    </button>
                  </div>
                ))
              ) : (
                <span className="text-xs text-slate-400 font-medium italic">No supporting documents uploaded yet.</span>
              )}
            </div>
          </div>
          <div className="mt-2 w-full">
            <FileInput
              prefix={params.formid}
              onchange={(file) => {
                let attachmenturl = store.getvalue("attachmenturl") || [];
                attachmenturl.push(file);
                store.setvalue("attachmenturl", attachmenturl);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function AccountDetails({ store, params }) {
  const customStringClass = {
    field: "flex flex-col gap-1.5 w-full",
    input: "w-full px-4 py-2.5 bg-[#f8fafc] border border-[#e2e8f0] rounded-xl text-sm text-[#1e293b] placeholder-[#94a3b8] focus:outline-none focus:border-[#4f46e5] focus:bg-[#ffffff] transition-all duration-300",
    lable: "w-fit text-xs font-semibold text-[#475569]"
  };

  return (
    <div className="flex flex-col gap-6">
      <div>
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Bank Account Details</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
          <String name="account_no" label="Account Number" doubleline={true} className={customStringClass} />
          <String name="account_holder_Name" label="Account Holder Name" doubleline={true} className={customStringClass} />
          <String name="bank_Name" label="Bank Name" doubleline={true} className={customStringClass} />
          <String name="branch" label="Branch Location" doubleline={true} className={customStringClass} />
          <String name="ifsC_Code" label="IFSC Code" doubleline={true} className={customStringClass} />
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Bank Proof Upload (Cancelled Cheque / Passbook)</span>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div className="col-span-1 md:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {store.getvalue("paymentAttachmentURL")?.length > 0 ? (
                store.getvalue("paymentAttachmentURL").map((item, index) => (
                  <div className="flex items-center justify-between border border-[#e2e8f0] p-3 rounded-xl bg-slate-50 text-xs" key={index}>
                    <Attachement name={"paymentAttachmentURL"} fileurl={item} />
                    <button
                      className="p-1 hover:bg-slate-200 text-red-500 rounded-lg cursor-pointer"
                      onClick={() => {
                        let arr = store.getvalue("paymentAttachmentURL").filter((_, i) => i !== index);
                        DeleteAttachement(item).then((res) => {
                          if (res.success) {
                            store.setvalue("paymentAttachmentURL", arr);
                          } else {
                            WarningAlert("Unable to remove attachment");
                          }
                        });
                      }}
                    >
                      <IoMdTrash size={16} />
                    </button>
                  </div>
                ))
              ) : (
                <span className="text-xs text-slate-400 font-medium italic">No bank proof documents uploaded.</span>
              )}
            </div>
          </div>
          <div className="mt-2 w-full">
            <FileInput
              prefix={params.formid}
              onchange={(file) => {
                let attachmenturl = store.getvalue("paymentAttachmentURL") || [];
                attachmenturl.push(file);
                store.setvalue("paymentAttachmentURL", attachmenturl);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ShootingDetails({ store, params }) {
  const customStringClass = {
    field: "flex flex-col gap-1.5 w-full",
    input: "w-full px-4 py-2.5 bg-[#f8fafc] border border-[#e2e8f0] rounded-xl text-sm text-[#1e293b] placeholder-[#94a3b8] focus:outline-none focus:border-[#4f46e5] focus:bg-[#ffffff] transition-all duration-300",
    lable: "w-fit text-xs font-semibold text-[#475569]"
  };

  return (
    <div className="flex flex-col gap-6">
      <div>
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Remuneration & Timeline Deal</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
          <Dropdown
            name="payment_Deal"
            label="Payment Deal Type"
            doubleline={true}
            className={{
              field: "flex flex-col gap-1.5 w-full px-0",
              lable: "w-fit text-xs font-semibold text-[#475569]",
              input: "w-full text-sm rounded-xl focus:border-[#4f46e5]"
            }}
            list={[
              { value: "Fixed Remuneration", label: "Fixed Remuneration" },
              { value: "Per day Remuneration", label: "Per day Remuneration" },
              { value: "Monthly Remuneration", label: "Monthly Remuneration" },
            ]}
          />
          <String name="total_Remuneration" label="Total Remuneration (Amount)" doubleline={true} className={customStringClass} />
          <String type="number" name="no_of_Shooting_Days" label="Estimated Shooting Days" doubleline={true} className={customStringClass} />
          <String name="no_of_Months" label="Duration (Months)" doubleline={true} className={customStringClass} />
        </div>
      </div>

      <div className="mt-4">
        <div className="flex items-center gap-3 text-slate-800 text-sm font-bold pb-2 border-b border-slate-100">
          <span>Payment Tranches / Stages Breakdown</span>
        </div>
        
        <div className="mt-4 bg-[#f8fafc] border border-[#e2e8f0] rounded-2xl p-4 flex flex-col gap-4">
          <div className="flex flex-col gap-3">
            {store.getvalue("payment_Trance")?.map((item, index) => (
              <div className="flex gap-3 items-center" key={index}>
                <div className="flex-1 bg-[#ffffff] border border-[#e2e8f0] rounded-xl px-3 py-1.5">
                  <input
                    type="text"
                    placeholder="e.g. Stage Name / On Completion"
                    className="w-full text-xs text-slate-700 bg-transparent border-0 outline-none"
                    value={item.name || ""}
                    onChange={(event) => {
                      let fieldName = event.target.value;
                      let payment_Trance = store.getvalue("payment_Trance");
                      payment_Trance[index].name = fieldName;
                      store.setvalue("payment_Trance", payment_Trance);
                    }}
                  />
                </div>
                <span className="text-slate-400 font-bold">=</span>
                <div className="w-[120px] bg-[#ffffff] border border-[#e2e8f0] rounded-xl px-3 py-1.5">
                  <input
                    type="text"
                    placeholder="Amount"
                    className="w-full text-xs text-slate-700 bg-transparent border-0 outline-none"
                    value={item.value || ""}
                    onChange={(event) => {
                      let fieldValue = event.target.value;
                      let payment_Trance = store.getvalue("payment_Trance");
                      payment_Trance[index].value = fieldValue;
                      store.setvalue("payment_Trance", payment_Trance);
                    }}
                  />
                </div>
                <button
                  className="p-2 hover:bg-slate-200 text-red-500 rounded-xl cursor-pointer transition-colors border-0 bg-transparent"
                  onClick={() => {
                    let payment_Trance = store.getvalue("payment_Trance");
                    let new_payment_Trance = payment_Trance.filter((_, i) => i !== index);
                    store.setvalue("payment_Trance", new_payment_Trance);
                  }}
                >
                  <IoMdTrash size={16} />
                </button>
              </div>
            ))}
            
            <button
              className="mt-2 w-fit px-4 py-2 border border-dashed border-slate-300 hover:border-slate-500 text-slate-600 rounded-xl font-bold flex justify-center items-center hover:bg-slate-50 cursor-pointer transition-all gap-1.5 text-xs bg-transparent"
              onClick={() => {
                let payment_Trance = store.getvalue("payment_Trance") || [];
                payment_Trance.push({ name: "", value: "" });
                store.setvalue("payment_Trance", payment_Trance);
              }}
            >
              <IoMdAdd size={16} /> Add Tranche Row
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
        <String name="assistants_Payments" label="Assistants Remuneration Deal" doubleline={true} className={customStringClass} />
        <Journal 
          name="remarks" 
          label="Remarks / Special Agreements" 
          doubleline={true} 
          className={{
            field: "flex flex-col gap-1.5 w-full",
            input: "w-full min-h-[90px] px-4 py-2.5 bg-[#f8fafc] border border-[#e2e8f0] rounded-xl text-sm text-[#1e293b] focus:outline-none focus:border-[#4f46e5] focus:bg-[#ffffff] transition-all duration-300",
            lable: "w-fit text-xs font-semibold text-[#475569]"
          }}
        />
      </div>
    </div>
  );
}

function SuccessSubmittion({ initialValue_for_Reset, MandatoryFunction, store }) {
  return (
    <div className="flex flex-col items-center py-10 text-center">
      <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6">
        <img className="w-12 h-12" src="/Assets/images/success.png" alt="Success Check" />
      </div>
      
      <h1 className="text-2xl font-extrabold text-[#000042] tracking-tight mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Submitted Successfully!
      </h1>
      <p className="text-xs text-slate-500 max-w-sm mb-8 leading-relaxed">
        Your onboarding information has been securely received by our system operations team and will be reviewed shortly.
      </p>

      <button
        className="px-6 py-2.5 bg-[#000042] text-[#ffffff] rounded-xl hover:bg-[#09095c] hover:shadow-lg active:scale-[0.98] transition-all font-semibold text-xs border-0 cursor-pointer shadow-md"
        onClick={() => {
          store.setvalue("activeform", 0);
          store.reset(initialValue_for_Reset);
          MandatoryFunction(0);
          SuccessAlert("New Form Initiated");
        }}
      >
        Onboard Another Person
      </button>
    </div>
  );
}

export default FilmFormCreate;
